import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { adminArtists, adminArtworks, adminExhibitions, adminJournal, adminEnquiries, adminNewsletter } from '@/lib/admin';

function StatCard({ label, value, to }) {
    const content = (
        <div className="rule-top pt-6">
            <span className="label" style={{ color: 'var(--ink-3)' }}>{label}</span>
            <div className="serif text-6xl md:text-7xl mt-3 leading-none">{value}</div>
        </div>
    );
    return to ? <Link to={to} className="block hover:opacity-80 transition-opacity">{content}</Link> : <div>{content}</div>;
}

export default function AdminDashboard() {
    const [stats, setStats] = useState(null);
    useEffect(() => {
        Promise.all([adminArtists.list(), adminArtworks.list(), adminExhibitions.list(), adminJournal.list(), adminEnquiries(), adminNewsletter()])
            .then(([artists, artworks, exhibitions, journal, enquiries, newsletter]) => {
                setStats({ artists: artists.length, artworks: artworks.length, exhibitions: exhibitions.length, journal: journal.length, enquiries: enquiries.length, newsletter: newsletter.length });
            }).catch(() => setStats({}));
    }, []);

    return (
        <div data-testid="admin-dashboard" className="py-10">
            <span className="section-no">§ Overview</span>
            <h1 className="serif text-5xl md:text-7xl mt-3 leading-[0.95]">Welcome back.</h1>
            <p className="literary mt-6 max-w-2xl">A quiet morning at the desk. Everything you publish lives here — artists, available works, exhibitions, the journal. Visitors' enquiries appear in the inbox.</p>

            <div className="grid grid-cols-2 md:grid-cols-3 gap-8 md:gap-12 mt-20">
                <StatCard label="Artists" value={stats?.artists ?? '—'} to="/admin/artists" />
                <StatCard label="Artworks" value={stats?.artworks ?? '—'} to="/admin/artworks" />
                <StatCard label="Exhibitions" value={stats?.exhibitions ?? '—'} to="/admin/exhibitions" />
                <StatCard label="Journal posts" value={stats?.journal ?? '—'} to="/admin/journal" />
                <StatCard label="Enquiries" value={stats?.enquiries ?? '—'} to="/admin/enquiries" />
                <StatCard label="Newsletter sign-ups" value={stats?.newsletter ?? '—'} to="/admin/newsletter" />
            </div>
        </div>
    );
}
